module.exports = __webpack_public_path__ + "img/tuiguang3-2-1.f661026f.png";